import cx from 'classnames';
import { Link } from 'wouter';

import { Button, ButtonSize } from '@atlas/components';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './ResetPassword.module.scss';

const ResetPasswordSuccess = () => {
  const layout = useLayout();

  return (
    <div
      className={cx(styles.content, styles['success-reset'], styles[layout])}
    >
      <div>
        <h3 className={styles.title}>
          <Translation message="success" />
        </h3>
        <p className={styles.description}>
          <Translation message="you_successfully_reset_your_password" />
        </p>
      </div>
      <Link to="/signin">
        <Button className={styles['signin-button']} size={ButtonSize.big}>
          <Translation message="log_in" />
        </Button>
      </Link>
    </div>
  );
};

export default ResetPasswordSuccess;
